<template>
  <a-tabs
    :v-model="customActiveKey"
    :tabBarStyle="{ textAlign: 'left', borderBottom: 'unset' }"
  >
    <a-tab-pane key="1" tab="主索引">
      <empi-list></empi-list>
    </a-tab-pane>
    <a-tab-pane key="2" tab="被合并的主索引">
      <empi-list status="2"></empi-list>
    </a-tab-pane>
  </a-tabs>
</template>

<script>
  import EmpiList from './list/EmpiList'
  export default {
    name: 'EmpiPanel',
    components: { EmpiList },
    data(){
      return {
        customActiveKey:'1'
      }
    },
  }
</script>

<style scoped>

</style>